import React from 'react';
import styled from 'styled-components';

/**
 * Tiny SVG sparkline. No charting library — keeps the bundle small and
 * matches the IciciOpsCenter visual language.
 *
 * Props:
 *   data:   number[]   (the bucketed values — usually length 24 for hourly)
 *   color:  string     (stroke + area-fill color)
 *   height: number     (px)
 */
const Wrap = styled.div`
  width: 100%;
  height: ${(p) => p.height}px;
  position: relative;
`;

const Sparkline = ({ data = [], color = '#22c55e', height = 56 }) => {
  if (!data.length) {
    return <Wrap height={height} />;
  }

  const w = 100;
  const h = 100;
  const max = Math.max(1, ...data);
  const stepX = w / Math.max(1, data.length - 1);

  const points = data
    .map((v, i) => `${(i * stepX).toFixed(2)},${(h - (v / max) * h).toFixed(2)}`)
    .join(' ');

  // Filled area path (close down to baseline)
  const areaPoints = `0,${h} ${points} ${w},${h}`;

  return (
    <Wrap height={height}>
      <svg
        viewBox={`0 0 ${w} ${h}`}
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        style={{ display: 'block' }}
      >
        <defs>
          <linearGradient id={`spark-grad-${color}`} x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.35" />
            <stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#spark-grad-${color})`} />
        <polyline
          points={points}
          fill="none"
          stroke={color}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </Wrap>
  );
};

export default Sparkline;
